<template>
  <div class="issues main">
    <MainBackButton />

    <div class="subtitle">Issues</div>

    <div class="field" style="margin-bottom: 0px">
      <p class="control has-icons-left has-icons-right">
        <input
          type="text"
          ref="input"
          class="input is-large is-light has-text-dark"
          v-model="searchVal"
          :placeholder="searchPlaceholder"
          @keyup="search($event.target.value)"
          @focus="search($event.target.value)"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-search fa-sm" style="margin-left: 7px" />
        </span>
        <span
          v-show="searchTerm"
          class="icon is-small is-right clear-search"
          @click="clearSearch"
        >
          <i class="fa fa-times-circle" />
        </span>
      </p>
    </div>

    <div class="result-header tabs is-fullwidth">
      <ul>
        <li
          :class="{ 'is-active': searchTab === 'shops' }"
          @click="searchTab = 'shops'"
        >
          <a>Shops</a>
        </li>
        <li
          :class="{ 'is-active': searchTab === 'menu' }"
          @click="searchTab = 'menu'"
        >
          <a>Menu Items</a>
        </li>
        <li
          :class="{ 'is-active': searchTab === 'categories' }"
          @click="searchTab = 'categories'"
        >
          <a>Categories</a>
        </li>
        <li
          v-if="$store.getters.isSuperUser"
          :class="{ 'is-active': searchTab === 'super' }"
          @click="searchTab = 'super'"
        >
          <a>All</a>
        </li>
      </ul>
    </div>

    <div class="scroll-list no-scrollbar">
      <div v-if="searchTab === 'shops'">
        <div v-if="searchResult.length">
          <div class="list is-hoverable">
            <span
              v-for="s in searchResult"
              v-ripple
              class="list-item has-text-left single-line is-flex"
              :key="s.key + s.value"
              @click="select(s)"
            >
              <span class="flex-img-wrapper">
                <img v-if="s.pic" :src="s.pic" />
                <img v-else :src="shopImg" class="no-pic" />
              </span>
              <span class="flex-name">{{ s.key }}</span>
            </span>
          </div>
        </div>
        <div v-else>
          <div v-if="isSearching" class="list">
            <span class="list-item" style="padding: 12px">
              <i class="fa fa-spinner fa-spin has-text-grey" />
            </span>
          </div>
          <div v-else class="list has-text-left" @click="clearSearch">
            <span
              class="list-item is-italic has-text-grey"
              style="padding: 12px"
            >
              <i v-if="searchTerm"
                >{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i
              >
              <i v-else>Search for shops</i>
            </span>
          </div>
        </div>
      </div>

      <div v-if="searchTab === 'menu'">
        <div v-if="menuItems">
          <div class="list is-hoverable">
            <span
              v-for="(s, i) in menuItems"
              v-ripple
              class="list-item has-text-left single-line"
              :key="'menuItems' + i"
              @click="selectWithSearch(s)"
            >
              <i
                class="fa fa-list fa-sm"
                style="opacity: 0.4; margin-right: 8px"
              />
              <span class="business-name">{{ s.business_name }}</span>
              <span class="is-pulled-right tag is-rounded">{{ s.count }}</span>
            </span>
          </div>
        </div>
        <div v-else class="list has-text-left" @click="clearSearch">
          <span class="list-item is-italic has-text-grey" style="padding: 12px">
            <i v-if="searchTerm"
              >{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i
            >
            <i v-else>Search for menu items</i>
          </span>
        </div>
      </div>

      <div v-if="searchTab === 'categories'">
        <div class="list has-text-left">
          <span class="list-item is-italic has-text-grey" style="padding: 12px">
            <i>Categories search coming soon!</i>
          </span>
        </div>
      </div>

      <div v-if="searchTab === 'super'">
        <div class="list has-text-left">
          <span class="list-item is-italic has-text-grey" style="padding: 12px">
            <i>Search all coming soon! (Superuser)</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import MainBackButton from "@/components/MainBackButton";

export default {
  name: "Search",
  components: {
    MainBackButton,
  },
  data() {
    return {
      searchTab: "shops",
      menuItems: null,
      searchPlaceholder: this.$t("home2.search"),
      isSearching: false,
      searchResult: [],
      noResults: false,
      searchVal: null,
      searchTerm: null,
      lastSearch: null, // store last search when searchVal/searchTerm clear
      shopImg: "/img/home2/shop-bw.png",
    };
  },
  computed: {
    frequentShops() {
      return this.$store.getters.getFrequentShops;
    },
    recentShops() {
      // return this.$store.getters.getRecentShops;
      var recent = this.deepCopy(this.$store.state.shopHistory);
      var sorted = recent.sort((a, b) => {
        return b.updated_at - a.updated_at;
      });
      if (sorted.length <= 6) return sorted;
      return sorted.slice(0, 6);
    },
    defaultShops() {
      var combined = this.recentShops.concat(this.frequentShops);
      // return [...new Set(combined)];
      return combined;
      // return combined.reduce((a, b) => {
      //   if (a.indexOf(b) < 0) a.push(b);
      //   return a;
      // }, []);
    },
  },
  mounted() {
    this.cycleSearchPlaceholder();

    if (!this.$store.getters.getUserLocation) {
      this.updateLocation();
      EventBus.$emit("OPEN_REGION_MODAL", null);
    } else {
      this.$refs.input.focus();
    }
  },
  //   activated() {
  //     console.log("search activated");
  //     this.search();
  //     setTimeout(() => this.$refs.input.focus(), 400);
  //   },
  //   deactivated() {},
  methods: {
    select(s) {
      this.logSearch(s);
      this.$nextTick(() => this.goto(`shop/${s.value}`));
    },
    selectWithSearch(s) {
      this.logSearch(s);
      var path = `shop/${s.business_id}?tab=menu&search=${this.searchTerm}`;
      this.$nextTick(() => this.goto(path));
    },
    logSearch(s) {
      s.term = this.lastSearch;
      this.log("search_success", s);
    },
    search(text) {
      if (!text) {
        this.searchResult = this.frequentShops; // this.defaultShops; //
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      //e) {
      //   var text = e.target.value; //   var text = this.searchVal;
      this.searchTerm = text; // a hack for mobile...
      this.lastSearch = text;
      console.log("search", text);
      if (text.length < 3) {
        console.log("frequentShops", this.$store.getters.getFrequentShops);
        this.searchResult = this.frequentShops.filter((s) =>
          s.key.toLowerCase().includes(text.toLowerCase())
        );
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      this.isSearching = true;
      this.$store
        .dispatch("autocompleteSearch", text)
        .then((res) => {
          if (res.data) {
            if (res.data.businesses) {
              this.searchResult = res.data.businesses;
              this.noResults = false;
            } else {
              this.searchResult = [];
              this.noResults = true;
            }
          } else {
            this.searchResult = [];
            this.noResults = true;
          }
        })
        .catch((err) => console.error("searchAutocomplete", err))
        .finally(() => (this.isSearching = false));
      // ----- search menus ----- //
      this.menuItems = null;
      this.$store
        .dispatch("searchMenuItems", text)
        .then((res) => (this.menuItems = res.data)) // no results if this is empty array []
        .catch((err) => console.error("searchAutocomplete", err))
        .finally(() => (this.isSearching = false));
    },
    clearSearch() {
      var delay = 10;
      setTimeout(() => {
        this.searchVal = null;
        this.searchTerm = null;
        this.noResults = false;
        this.searchResult = this.frequentShops;
        this.menuItems = null;
      }, delay);
      setTimeout(() => (this.searchResult = []), delay);
      //   this.$nextTick(() => (this.searchResult = [])); // don't know why this didn't work
    },
    cycleSearchPlaceholder() {
      var strings = [
        "search-shops",
        "search-restaurants",
        "search-services",
        "search-transport",
        "search-anything",
        "search",
      ]; // blank at end
      var i = 0;
      setInterval(() => {
        i += 1;
        if (i >= strings.length) i = 0;
        this.searchPlaceholder = this.$t(`home2.${strings[i]}`);
      }, 1500);
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: #fff5d1;
  z-index: 4;
  overflow: hidden;
}
.input {
  border-radius: 0px;
}
.subtitle {
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 0;
  text-align: left;
  padding: 16px;
  margin-left: 40px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
}
.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: inline-block; */
}
.list {
  border-radius: 0;
  margin-bottom: 0;
}
.list-item {
  border-radius: 0;
  border-bottom: 1px solid rgba(238, 238, 238, 0.6);
  padding-right: 8px;
}
.list-item:hover {
  outline: 1px solid var(--warning);
}
.business-name {
  max-width: calc(100vw - 76px);
  display: inline-block;
  vertical-align: bottom;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-header {
  text-align: left;
  color: rgba(128, 128, 128, 0.9);
  padding: 9px 12px;
  font-weight: 500;
  background-color: rgba(255, 255, 0, 0.3);
  margin-bottom: 0;
  padding: 0;
  /* border-top: 1px solid rgb(235, 235, 235); */
}
li a {
  color: #aaa;
}
li a:hover {
  color: #777;
  border-bottom: 2px solid #999;
}
li.is-active a {
  color: #333;
  border-bottom: 2px solid #555;
}
.scroll-list {
  max-height: calc(100vh - 120px);
  padding-bottom: 80px;
  overflow: auto;
  margin-top: 1px;
}
.fa-store-alt {
  opacity: 0.4;
  margin-right: 8px;
}
.flex-img-wrapper {
  flex-shrink: 1;
  object-fit: cover;
  height: 64px;
  width: 64px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}
.flex-name {
  flex: 1;
  padding-left: 9px;
  line-height: 64px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.is-flex.list-item {
  padding: 0;
}
.clear-search {
  /* pointer-events: initial; */
  pointer-events: all !important;
  cursor: pointer;
  color: #bbb !important;
}
.no-pic {
  padding: 10px;
  opacity: 0.6;
}
</style>